export const featuresList = [
  {
    featureName: "Blog Headlines",
  },
  {
    featureName: "Blog Intros",
  },
  {
    featureName: "Content Rewriter",
  },
  {
    featureName: "Facebook Ads",
  },
  {
    featureName: "Product Description",
  },
  {
    featureName: "PAS Copywriting Formula",
  },
];
